import React, { useState } from 'react';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import { Icon } from '../../../common/components/Utilities';
import RestrictedContent from '../../../common/components/RestrictedContent';

function SupportEmail({ groups, csrfToken }) {
  const [loading, setLoading] = useState(false);

  const sendEmails = async () => {
    setLoading(true);

    try {
      await axios.post('/support/accounting-emails', {}, {
        headers: {
          'X-CSRF-Token': csrfToken,
        },
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <RestrictedContent group={groups.OPERATIONS}>
      <Button variant="outline-primary" block disabled={loading} onClick={sendEmails} className="mb-2 text-left">
        <Icon icon="envelope" variant="fad" append="mr-2" />
        {' '}
        Send Accounting Emails
      </Button>
    </RestrictedContent>
  );
}

export default SupportEmail;
